import { isAaaGameInformationGameExpectationsValid } from "../../../../helpers/formValidation";
import { hasHandheldOptimizationRequiredPlatform } from "../../../../helpers/handheldOptimizationHelpers";
import { hasXboxPlayAnywhereRequiredPlatforms } from "../../../../helpers/xboxPlayAnywhereHelpers";
import { OnboardingErrorMessage } from "../../../../models/errors";
import {
  AaaGameInformationGameExpectationsDataType,
  SubFormsDataTypes,
} from "../../../../models/forms";
import { DataFilterResult, IDataFilter } from "../dataFilter";

export const AaaGameExpectationsDataFilter: IDataFilter = {
  validate: async (data: SubFormsDataTypes | undefined): Promise<DataFilterResult> => {
    const gameExpectationsData = data as AaaGameInformationGameExpectationsDataType;
    if (!gameExpectationsData) {
      return { result: true };
    }

    const validSchema = await isAaaGameInformationGameExpectationsValid(gameExpectationsData);
    const validXboxPlayAnywherePlatforms = hasXboxPlayAnywhereRequiredPlatforms(
      gameExpectationsData.xboxPlayAnywhere,
      gameExpectationsData.targetPlatforms
    );
    const validHandheldOptimizationPlatform = hasHandheldOptimizationRequiredPlatform(
      gameExpectationsData.handheldOptimization,
      gameExpectationsData.targetPlatforms
    );
    return {
      result: validSchema && validXboxPlayAnywherePlatforms && validHandheldOptimizationPlatform,
      message: !validXboxPlayAnywherePlatforms
        ? OnboardingErrorMessage.xboxPlayAnywherePlatformsRequired
        : !validHandheldOptimizationPlatform
        ? OnboardingErrorMessage.handheldOptimizationPlatformRequired
        : undefined,
    };
  },
};
